<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      :breadcrumbs="breadcrumbs"
      icon=""
    ></vuse-section-definition>
    <v-container fluid class="">

    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      namespace: "Roles",
      page: "Roles",
      usage: "usage",
      breadcrumbs: [
        {
          text: "App",
          disabled: true,
        },
        {
          text: "User",
          disabled: true,
        },
        {
          text: "Roles",
          disabled: false,
          to: {
            path: "/pages/user/roles",
          },
        },
      ],
    };
  },
};
</script>